import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedIconsModule } from '../shared-icons/shared-icons.module';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@app/directives/directives.module';
import { PickrightButtonComponent } from './button.component';



@NgModule({
  declarations: [
    PickrightButtonComponent
  ],
  imports: [
    CommonModule,
    SharedIconsModule,
    RouterModule,
    DirectivesModule
  ],
  exports: [
    PickrightButtonComponent
  ]
})
export class ButtonModule { }
